import React, { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import styled from 'styled-components';
import { Typography, Button } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import TopBar from 'components/TopBar';
import TransitionScreen from 'components/shared/TransitionScreen';
import Stack from 'components/shared/Stack';

import { apiChangeAvailability } from 'state/common.actions';
import store, { RootState } from 'state/store';
import { browserHistory } from 'utils/functions';

const SplashContent = styled('div')`
  margin-top: auto;
  text-align: center;

  .splash-text {
    font-weight: bold;
  }

  .splash-action {
    padding-left: ${(props) => props.theme.spacing(5)};
    padding-right: ${(props) => props.theme.spacing(5)};
    text-transform: none;
  }
`;

const ConciergeTransitionScreen = () => {
  const dispatch = useDispatch();
  const { conciergeIsActive, assignedLeadId, completedOneLead, isAwaitingNewLead } = useSelector(
    (state: RootState) => ({
      conciergeIsActive: state.concierge.isActive,
      assignedLeadId: state.concierge.assignedLeadId,
      completedOneLead: state.concierge.completedOneLead,
      isAwaitingNewLead: state.concierge.isAwaitingNewLead,
    }),
    shallowEqual
  );
  const theme = useTheme();

  // clear out old lead when welcome screen is rendered
  useEffect(() => {
    store.dispatch({ type: 'RESET_LEAD' });
  }, []);

  useEffect(() => {
    if (!isAwaitingNewLead && assignedLeadId) {
      browserHistory.push(`/${assignedLeadId}`);
    }
  }, [assignedLeadId, isAwaitingNewLead]);

  const handleBtnClick = () => {
    dispatch(apiChangeAvailability({ isActive: true }));
  };

  return (
    <TransitionScreen>
      <TopBar />
      <SplashContent>
        {conciergeIsActive ? (
          <>
            {completedOneLead && (
              <Typography className="splash-text" variant="h1" color="primary">
                Nice Work!
              </Typography>
            )}
            <Typography variant="h4" color="primary">
              Hang tight while we fetch a new lead.
            </Typography>
          </>
        ) : (
          <Stack space={theme.spacing(4)}>
            <div>
              <Typography className="splash-text" variant="h1" color="primary">
                Welcome Back!
              </Typography>
              <Typography variant="h4" color="primary">
                Click below when you’re ready for a lead
              </Typography>
            </div>
            <div>
              <Button
                type="button"
                className="splash-action"
                variant="contained"
                color="primary"
                onClick={handleBtnClick}
              >
                <Typography className="splash-text" variant="h2">
                  {"Let's Go"}
                </Typography>
              </Button>
            </div>
          </Stack>
        )}
      </SplashContent>
    </TransitionScreen>
  );
};

export default ConciergeTransitionScreen;
